__webpack_require__.p = "/local/templates/Leggis/assets/build/";